// based on https://auth0.com/blog/secure-your-react-and-redux-app-with-jwt-authentication/
// middleware/api.js

export const CALL_API = Symbol('Call API')

const BASE_URL = __API_URL__

function callApi(endpoint, config = {}) {

  config = {
    ...config,
    headers: {
      'Content-type': 'application/json',
      ...config.headers
    }
  }

	if (config.authenticated && config.token) {
    config = {
      ...config,
      headers: {
        'Authorization': `Bearer ${config.token}`,
        ...config.headers
      }
    }
  }


	return fetch(BASE_URL + endpoint, config)
		.then(response =>
      response.json()
        .then(data => ({
            data,
            response
          }), err => ({ // json parse error - usually because there is no data
            response
          })
        )
    )
    .then(({ data, response }) => {
      if (!response.ok) {
        return Promise.reject(data)
      }
      return {data, response}
    })
}


export default store => next => action => {

	const callAPI = action[CALL_API]

	// So the middleware doesn't get applied to every single action
	if (typeof callAPI === 'undefined') {
		return next(action)
	}

	let { endpoint, types, ...config } = callAPI

	const [requestType, successType, errorType] = types

	next({
		type: requestType
	})

  var {auth: {accessToken} = {}} = store.getState()
  config = {  ...config, token: accessToken }

	return callApi(endpoint, config).then(
    ({data, response }) =>
		next({
			data,
      response,
			config,
			type: successType
		}),
		error => next({
			error: (error && error.message) || 'There was an error.',
			type: errorType,
			config
		})
	)
}



/** WEBPACK FOOTER **
 ** ./src/middleware/api.js
 **/